import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	selector: 'rx-save-continue-scanner-icon',
	template: `
		<svg width="28" height="24" viewBox="0 0 28 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
			<path
				d="M25 0H3C2.46957 0 1.96086 0.210714 1.58579 0.585786C1.21071 0.960859 1 1.46957 1 2V8C0 8.5 0 9.5 0 9.5V18C0 18.5304 0.210714 19.0391 0.585786 19.4142C0.960859 19.7893 1.46957 20 2 20H14V22H10V24H18V22H14V20H26C26.5304 20 27.0391 19.7893 27.4142 19.4142C27.7893 19.0391 28 18.5304 28 18V9.5C28 9.5 28 8.5 27 8V2C27 1.46957 26.7893 0.960859 26.4142 0.585786C26.0391 0.210714 25.5304 0 25 0ZM25 17H3V2H25V17Z"
				fill="#0067AC"
			/>
		</svg>
	`,
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true
})
export class SaveContinueScannerIconComponent {}
